import { render, staticRenderFns } from "./FloorFigureCreate.vue?vue&type=template&id=76e6f742&"
import script from "./FloorFigureCreate.vue?vue&type=script&lang=js&"
export * from "./FloorFigureCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports